import { has, isString, isDate as isDateObject } from 'lodash-es';
export function isJSON(value) {
    if (typeof value !== 'string') {
        return false;
    }
    try {
        JSON.parse(value);
        return true;
    }
    catch (error) {
    }
    return false;
}
export function isDate(value) {
    if (!value) {
        return false;
    }
    let date = null;
    if (has(value, 'date') &&
        has(value, 'timezone') &&
        has(value, 'timezone_type')) {
        date = value.date;
    }
    else {
        date = value;
    }
    if (isDateObject(date)) {
        return true;
    }
    if (isString(date)) {
        if (!/^\d{4}-\d{2}-\d{2}/.test(date)) {
            return false;
        }
        let timestamp = Date.parse(date);
        if (isNaN(timestamp)) {
            return false;
        }
        if (timestamp) {
            return true;
        }
    }
    return false;
}
